/**
 * The KYC/KYB section with its confidence outcome attached.
 *
 * A view rather than a component because it reads the outcome from
 * `CustomerConfidenceProvider` and so cannot be rendered by an application that knows nothing about
 * the person API. The presentation it wraps, `KycVerificationSection`, is a component and lives in
 * `@verifime/components`.
 *
 * `documentRows` is exported alongside it because the mapping from a customer's documents to table
 * rows, and the API-shaped document types it reads, belong in this layer: they are an API concern,
 * not a presentational one. `TCustomerDocuments` is exported for the same reason `ConfidenceCustomerPage`
 * needs it: it is the shape a caller assembles a customer's document slots into before handing
 * them to this view.
 */
export { default as KycVerificationSectionView } from './KycVerificationSectionView';
export type { TKycVerificationSectionViewProps } from './KycVerificationSectionView';

export { documentRows } from './documentRows';
export type {
  TCustomerDocuments,
  TKycDriverLicence,
  TKycImmiCard,
  TKycMedicareCard,
  TKycOtherIdentityDocument,
  TKycPassport,
  TKycPhotoCard,
} from './documentRows';
